export default "__VITE_ASSET__C32rlst4__"